<template>
    <b-overlay :show="show" :variant="variant" :opacity="opacity" :blur="blur" rounded="sm" spinner-variant="primary">
        <b-card>
            <h1>{{ $t("Workspace") }}</h1>
    
            <div class="vx-row mt-5" v-if="!this.$route.params.id">
                <div class="vx-col md:w-2/3">
    
                    <label>{{ $t("AllowForWorkspace") }}</label>
                </div>
    
                <div class="vx-col md:w-1/3">
    
                    <b-form-checkbox id="tooltip-target-2" v-model="value" size="lg" name="cell_width" @change="workspaceBackgroundAction()" switch>
                    </b-form-checkbox>
    
                </div>
            </div>
            <div class="vx-col md:w-full mt-5">
                <b>{{ $t("BackgroundImages") }}</b>
                <p class="mt-2">{{ $t('SuggestedImagesSize') }}: <b>1600x900px</b></p>
            </div>
            <div class="vx-col md:w-full mt-5">
                <b-table-simple>
                    <b-tbody>
                        <b-tr>
                            <b-th>{{ $t("Image") }}</b-th>
                            <b-th>{{ $t("Actions") }}</b-th>
                        </b-tr>
                        <b-tr v-if="background_images.length == 0">
                            <b-th colspan="3">
                                <div class="text-center">{{ $t("ImagesNotUploaded") }}</div>
                            </b-th>
                        </b-tr>
                        <b-tr v-for="(bg_image, index) in background_images" :key="index">
                            <b-td>{{ bg_image.background_image.file}}</b-td>
                            <b-td>
                                <feather-icon v-b-tooltip.hover :title="$t('View')" icon="EyeIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="redirectToImage( bg_image.background_image.path)" />
                                <feather-icon v-b-tooltip.hover :title="$t('Delete')" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="confirmPoup('delete', bg_image.id)" />
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>
            <div class="vx-row mt-5">
                <div class="vx-col md:w-full">
                    <b-button variant="primary" type="filled" @click.prevent class="mt-5" @click="$refs.file.click()">{{ $t("Upload") }}</b-button>
                    <input type="file" class="hidden" multiple="multiple" ref="file" accept="image/*" name="image" id="image" @change="selectedFile" />
                    <!-- <b-button v-if="!this.$route.params.id" variant="dark" type="filled" @click.prevent="confirmPoup('restore')" class="ml-5 mt-5">{{ $t("RestoreDefaultBackground") }}</b-button> -->
                </div>
            </div>
    
    
        </b-card>
    </b-overlay>
</template>

<script>
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import $ from "jquery";
export default {
    components: {
        vSelect,
    },
    data() {
        return {
            show: false,
            variant: "light",
            opacity: 0.85,
            blur: "2px",
            error: "",
            success: "",
            background_images: [],
            urls: [],
            images: [],
            value: false,
            is_staff: this.$route.params.id ? 1 : 0
        };
    },
    watch: {
        "$i18n.locale": {
            handler: function(value) {
                this.loadLocale(value);
            },
        },
    },
    created() {
        this.getWorkspaceImage();
        if(['admin', 'assistant'].indexOf(this.$store.getters.userRole) > -1)
            this.getCompanyDetails();
    },
    methods: {

        getCompanyDetails() {
            this.show = true;
            this.$store
                .dispatch("showCompanyProfile", this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.id : this.$store.getters.currentUser.staff_id)
                .then((res) => {
                    this.value = res.data.data.is_allow_workspace_bkg ? true : false;
                    this.show = false;
                })
                .catch((error) => {
                    this.$log.error(
                        "File : Add.vue | Function : getCompanyDetails() | Error :",
                        error
                    );
                    console.log(error);
                    this.show = false;
                    // Error response
                    this.error =
                        this.$t(error.replace(/[\s\/]/g, "")) !==
                        error.replace(/[\s\/]/g, "") ?
                        this.$t(error.replace(/[\s\/]/g, "")) :
                        error;
                    this.$toasted.show(this.error, {
                        className: "top-alert",
                        position: "top-center",
                        type: "error",
                        duration: 2000,
                    });
                    return false;
                });
        },

        getWorkspaceImage() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    var form_data = new FormData();
                    form_data.append('company_id', this.$store.getters.company_id);
                    form_data.append('is_staff', this.is_staff);

                    this.$store
                        .dispatch("GetWorkspaceImage", form_data)
                        .then((res) => {
                            this.background_images = res.data.data;
                        })
                        .catch((error) => {
                            this.$log.error(
                                "File : workspace.vue | Function : getWorkspaceImage() | Error :",
                                error
                            );
                            this.show = false;
                            // Error response
                            this.error =
                                this.$t(error.replace(/[\s\/]/g, "")) !==
                                error.replace(/[\s\/]/g, "") ?
                                this.$t(error.replace(/[\s\/]/g, "")) :
                                error;
                            this.$toasted.show(this.error, {
                                className: "top-alert",
                                position: "top-center",
                                type: "error",
                                duration: 2000,
                            });
                            return false;
                        });
                }
            });
        },

        selectedFile(event) {
            this.error = "";
            this.urls = [];
            this.images = [];
            if (event.target.files.length > 0) {
                for (var i = 0; i < event.target.files.length; i++) {
                    var filePath = event.target.files[0].name;
                    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
                    if (!allowedExtensions.exec(filePath)) {
                        this.error =
                            this.$t(error.replace(/[\s\/]/g, "")) !==
                            error.replace(/[\s\/]/g, "") ?
                            this.$t(error.replace(/[\s\/]/g, "")) :
                            error;
                        this.$toasted.show(this.error, {
                            className: "top-alert",
                            position: "top-center",
                            type: "error",
                            duration: 2000,
                        });
                        $("#uploadDocument").val("");
                    } else {
                        this.images.push(event.target.files[i]);
                        this.urls.push(URL.createObjectURL(this.images[i]));
                    }
                }
                this.saveBackgroungImages();
            }
        },

        saveBackgroungImages() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.show = true;
                    var form_data = new FormData();
                    form_data.append('company_id',  this.$store.getters.company_id);
                    form_data.append('background_image_count', this.images.length);
                    form_data.append('is_staff', this.is_staff);
                    for (var i = 0; i < this.images.length; i++) {
                        form_data.append('background_image' + (i + 1), this.images[i]);
                    }

                    this.$store
                        .dispatch("SaveWorkspaceImages", form_data)
                        .then((res) => {
                            this.getWorkspaceImage();
                            this.urls = [];
                            this.images = [];
                            this.show = false;
                            this.$toasted.show(this.$t("ImagesUploadedSuccess"), {
                                className: "top-alert",
                                position: "top-center",
                                type: "success",
                                duration: 2000,
                            });
                        })
                        .catch((error) => {
                            this.$log.error(
                                "File : Workspace.vue | Function : saveBackgroungImages() | Error :",
                                error
                            );
                            this.show = false;
                            // Error response
                            this.error =
                                this.$t(error.replace(/[\s\/]/g, "")) !==
                                error.replace(/[\s\/]/g, "") ?
                                this.$t(error.replace(/[\s\/]/g, "")) :
                                error;
                            this.$toasted.show(this.error, {
                                className: "top-alert",
                                position: "top-center",
                                type: "error",
                                duration: 2000,
                            });
                            return false;
                        });
                }
            });
        },

        confirmPoup(type, delete_id = 0) {
            this.$swal({
                    text: type == "restore" ? this.$t("RestoreDefaultBackgroundConfirmation") : this.$t("ConfirmDeleteImage"),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: this.$t("Yes"),
                    confirmButtonColor: "#7367F0",
                    cancelButtonText: this.$t("No"),
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        if (type == 'restore')
                            this.restoreWorkspace(true);
                        else
                            this.deleteImage(delete_id);

                    }
                })
        },

        deleteImage(id) {
            this.$store
                .dispatch("DeleteWorkspaceImage", id)
                .then((res) => {
                    this.$toasted.show(this.$t("ImageDeleteSuccess"), {
                        className: "top-alert",
                        position: "top-center",
                        type: "success",
                        duration: 2000,
                    });
                    this.getWorkspaceImage();

                }).catch((error) => {
                    this.$log.error(
                        "File : BookingForm.vue | Function : deleteImage() | Error :",
                        error
                    );
                    this.show = false;
                    // Error response
                    this.error =
                        this.$t(error.replace(/[\s\/]/g, "")) !==
                        error.replace(/[\s\/]/g, "") ?
                        this.$t(error.replace(/[\s\/]/g, "")) :
                        error;
                    this.$toasted.show(this.error, {
                        className: "top-alert",
                        position: "top-center",
                        type: "error",
                        duration: 2000,
                    });
                    return false;
                });
        },

        redirectToImage(url) {
            window.open(url, '_blank');

        },

        workspaceBackgroundAction() {
            var data = {
                is_allow_workspace_bkg: this.value ? 1 : 0,
                company_id: this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id,
            };
            this.$store
                .dispatch("UpdateWorkspaceBkgImgFlag", data)
                .then((res) => {
                    this.show = false;

                    this.$toasted.show(this.$t("StatusUpdated"), {
                        className: "top-alert",
                        position: "top-center",
                        type: "success",
                        duration: 2000,
                    });
                })
                .catch((error) => {
                    this.$log.error(
                        "File : workspace.vue | Function : workspaceBackgroundAction() | Error :",
                        error
                    );
                    this.show = false;
                    // Error response
                    this.error =
                        this.$t(error.replace(/[\s\/]/g, "")) !==
                        error.replace(/[\s\/]/g, "") ?
                        this.$t(error.replace(/[\s\/]/g, "")) :
                        error;
                    this.$toasted.show(this.error, {
                        className: "top-alert",
                        position: "top-center",
                        type: "error",
                        duration: 2000,
                    });
                    return false;
                });
        },
    },
};
</script>









